import { createFileRoute } from '@tanstack/react-router';
import posthog from 'posthog-js';
import { z } from 'zod';

import { postCandidateTasksFilterOptions } from 'client/@tanstack/react-query.gen';

const schema = z.object({
  goal: z.string().optional(),
  module: z.string().optional(),
  task: z.string().optional(),
});

export type SearchSchema = z.infer<typeof schema>;

export const Route = createFileRoute(
  '/_private/_route/_internal/people/$identityId/_candidate/tasks',
)({
  loader: async ({ context }) => {
    const { queryClient } = context;
    const pTasks = queryClient.ensureQueryData(
      postCandidateTasksFilterOptions({
        body: {
          page: 1,
          page_size: 100,
          with_goals: posthog.isFeatureEnabled('project-account-plan-2')
            ? false
            : undefined,
        },
        path: {
          candidate_uuid: context.candidate.uuid,
        },
      }),
    );
    await Promise.all([pTasks]);
  },
  validateSearch: schema,
});
